export default __webpack_public_path__ + "resources/docs/6_financial_planning_tips_compressed.b2a9be98.pdf";